/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StoreItemVolumeDetailModel } from './StoreItemVolumeDetailModel';
import {
    StoreItemVolumeDetailModelFromJSON,
    StoreItemVolumeDetailModelFromJSONTyped,
    StoreItemVolumeDetailModelToJSON,
} from './StoreItemVolumeDetailModel';
import type { StoreItemVolumeLinkModel } from './StoreItemVolumeLinkModel';
import {
    StoreItemVolumeLinkModelFromJSON,
    StoreItemVolumeLinkModelFromJSONTyped,
    StoreItemVolumeLinkModelToJSON,
} from './StoreItemVolumeLinkModel';

/**
 * コミチプラスでの単行本情報
 * @export
 * @interface StoreItemVolumeModel
 */
export interface StoreItemVolumeModel {
    /**
     * 
     * @type {StoreItemVolumeDetailModel}
     * @memberof StoreItemVolumeModel
     */
    summary?: StoreItemVolumeDetailModel;
    /**
     * 単行本を購入できる各書店へのリンク
     * @type {Array<StoreItemVolumeLinkModel>}
     * @memberof StoreItemVolumeModel
     */
    storeItemVolumeLinks?: Array<StoreItemVolumeLinkModel>;
    /**
     * 管理者モードフラグ
     * @type {boolean}
     * @memberof StoreItemVolumeModel
     */
    isAdminMode?: boolean;
}

/**
 * Check if a given object implements the StoreItemVolumeModel interface.
 */
export function instanceOfStoreItemVolumeModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StoreItemVolumeModelFromJSON(json: any): StoreItemVolumeModel {
    return StoreItemVolumeModelFromJSONTyped(json, false);
}

export function StoreItemVolumeModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreItemVolumeModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'summary': !exists(json, 'summary') ? undefined : StoreItemVolumeDetailModelFromJSON(json['summary']),
        'storeItemVolumeLinks': !exists(json, 'storeItemVolumeLinks') ? undefined : ((json['storeItemVolumeLinks'] as Array<any>).map(StoreItemVolumeLinkModelFromJSON)),
        'isAdminMode': !exists(json, 'isAdminMode') ? undefined : json['isAdminMode'],
    };
}

export function StoreItemVolumeModelToJSON(value?: StoreItemVolumeModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'summary': StoreItemVolumeDetailModelToJSON(value.summary),
        'storeItemVolumeLinks': value.storeItemVolumeLinks === undefined ? undefined : ((value.storeItemVolumeLinks as Array<any>).map(StoreItemVolumeLinkModelToJSON)),
        'isAdminMode': value.isAdminMode,
    };
}

